import { useState, useRef } from 'react'
import { ActionIcon, Tooltip, Button } from '@mantine/core'
import { BarChart07, Plus } from '@untitled-ui/icons-react'
import InvlevelHistory from '@/components/ui/InvlevelHistory'
import AddStockMovementModal from '@/components/service_cases/ui/AddStockMovementModal'

export default function ServiceCaseStock({ serviceCase, onMutate }) {
    const [addModalOpened, setAddModalOpened] = useState(false)
    const invlevelHistoryRef = useRef(null)

    const handleSuccess = () => {
        invlevelHistoryRef.current?.fetch()
        onMutate?.()
    }

    const footerActions = (
        <div className="flex justify-center pt-4">
            <Button
                variant="default"
                size="xs"
                leftSection={<Plus width={14} height={14} />}
                onClick={() => setAddModalOpened(true)}
            >
                Enregistrer un mouvement de stock
            </Button>
        </div>
    )

    return (
        <>
            <InvlevelHistory
                ref={invlevelHistoryRef}
                service_case_id={serviceCase.id}
                title={`Stock — ${serviceCase.display_name}`}
                footerActions={footerActions}
            >
                {(open) => (
                    <Tooltip label="Mouvements de stock">
                        <div className="relative" onClick={open}>
                            <ActionIcon variant="default" size={36}>
                                <BarChart07 width={16} height={16} />
                            </ActionIcon>
                            {serviceCase.stock_out_count > 0 && (
                                <span className="absolute -bottom-1.5 -left-1.5 bg-red-500 text-white text-[9px] font-semibold leading-none min-w-[16px] h-[16px] flex items-center justify-center rounded-full px-1 pointer-events-none">
                                    {serviceCase.stock_out_count}
                                </span>
                            )}
                            {serviceCase.stock_in_count > 0 && (
                                <span className="absolute -bottom-1.5 -right-1.5 bg-green-500 text-white text-[9px] font-semibold leading-none min-w-[16px] h-[16px] flex items-center justify-center rounded-full px-1 pointer-events-none">
                                    {serviceCase.stock_in_count}
                                </span>
                            )}
                        </div>
                    </Tooltip>
                )}
            </InvlevelHistory>

            <AddStockMovementModal
                serviceCase={serviceCase}
                opened={addModalOpened}
                onClose={() => setAddModalOpened(false)}
                onSuccess={handleSuccess}
            />
        </>
    )
}
